import {Component, EventEmitter, Inject, Input, OnInit, Output, ViewChild} from '@angular/core';
import {
    MatCheckboxChange,
    MatTabGroup
} from '@angular/material';
import {TestsuiteComponent} from '../testsuite.component';
import {MatDialog, MAT_DIALOG_DATA} from '@angular/material/dialog';
import {MatDialogRef} from '@angular/material';
import {ConnecttocrudService} from '../../connecttocrud.service';
import {LeftpanelComponent} from '../../leftpanel/leftpanel.component';
import {DevexListenerService} from '../../devex-listener.service';
import {ActivatedRoute, Router} from '@angular/router';
import {JsonEditorComponent, JsonEditorOptions} from 'ang-jsoneditor';
import {HeadersComponent} from '../../devex/headers/headers.component';
import {ConfService} from '../../conf.service';
import {FormBuilder} from '@angular/forms';
import {Location} from '@angular/common';
import {AuthorizationComponent} from '../../authorization/authorization.component';
import {TestCaseNameInputDialog} from '../../testcase/testcase.component';
import {ConfirmTestcaseDeletionComponent} from '../testsuite.component';
import {COMMA, ENTER} from '@angular/cdk/keycodes';
import {TestsuiteListenerService} from '../../testsuite-listener.service';

export interface TestCaseData {
    name: string;
    type: string;
}

declare let $;

@Component({
    selector: 'app-test-executor',
    templateUrl: './test-executor.component.html',
    styleUrls: ['./test-executor.component.scss']
})


export class TestExecutorComponent implements OnInit {

    isLinear = true;
    @Input() partner = localStorage.getItem('partner');
    @Input() account = localStorage.getItem('account');
    @Input() executor_name = '';
    @Input() executor_version = '';
    @Input() editFlag: boolean;
    @Input() type: any;
    preStepsList = [];
    tearDownStepsList = [];
    stepsSearchText: any;
    tearDownStepsSearchText: any;
    columns = [];
    parameters = [];
    showParameters = false;
    templateParameters = [];
    recipientSpecificParameters = [];

    recipientSpecificParametersPayload = [];
    dummyPayload = {};
    count = 0;

    httpOperation: any;
    httpOperations = [
        {'name': 'GET'},
        {'name': 'POST'},
        {'name': 'PUT'},
        {'name': 'PATCH'},
        {'name': 'DELETE'}
    ];
    httpUrl: string;
    parametersHeaders = ['key', 'value', 'description'];
    parameterData = [];
    pathParameter = [];
    headersData = [];
    formData = [];
    requestBodySelected = 'none';
    confirmationWithoutResponseAttributes = {confirmation: ''};
    requestBodyTypes = [
        {'displayName': 'None', 'value': 'none'},
        {'displayName': 'Form Data', 'value': 'form-data'},
        {'displayName': 'Form URL Encoded', 'value': 'x-www-form-urlencoded'},
        {'displayName': 'Raw', 'value': 'raw'},
        {'displayName': 'Binary / File', 'value': 'binary'}

    ];

    @ViewChild(JsonEditorComponent) editor: JsonEditorComponent;
    @ViewChild(AuthorizationComponent) authModel1: AuthorizationComponent;
    @ViewChild(HeadersComponent) headerChild: HeadersComponent;
    @ViewChild('tabref4') tabref4: MatTabGroup;
    @Output() onCompletingTestCases: EventEmitter<any> = new EventEmitter<any>();
    @Output() onCompletingPreSteps: EventEmitter<any> = new EventEmitter<any>();
    @Output() onCompletingTearDownSteps: EventEmitter<any> = new EventEmitter<any>();

    options1 = new JsonEditorOptions();

    showPathParameters: boolean;
    devExURL = '';
    isCountOfResAtt: boolean;
    pathParameterSegregator: any;
    find: any;
    pathParameterStopper: any;
    pathParameterValue: any;

    requestBody: any;
    testcaseRequestBody = [];
    rawRequestBody: any;

    authAttributes = {};
    authModel = {
        'authAttributes': this.authAttributes
    };

    formDataTrue = true;
    formURLEncodedTrue = true;

    responseData: any;
    errorMessage: any;
    responseError: any;

    executorName: string;
    executorVersion: string;
    executor_url: string;
    executor_type = 'API';
    executor_method_type: string;
    executors: any;

    apiByDefinition: any;
    categories: any;
    entities = [];

    APIExecutorCategory = [];
    businessLogicAPIExecutorCategory = [];
    thirdPartyAPIExecutorCategory = [];
    SQLQueryAPIExecutorCategory = [];
    WorkflowAPIExecutorCategory = [];

    DataAccessAPIByCategory = [];
    businessLogicAPIByCategory = [];
    thirdPartyAPIByCategory = [];
    SQLQueryAPIByCategory = [];
    WorkflowAPIByCategory = [];

    basicPermission: boolean;

    DisplayApiByCategory = true;

    APITypes = [
        {
            type: 'Data Access API',
            category: this.APIExecutorCategory
        },
        {
            type: 'Business Logic API',
            category: this.businessLogicAPIExecutorCategory
        },
        {
            type: 'Third Party API',
            category: this.thirdPartyAPIExecutorCategory
        },
        {
            type: 'SQL Query API',
            category: this.SQLQueryAPIExecutorCategory
        },
        {
            type: 'Workflow API',
            category: this.WorkflowAPIExecutorCategory
        }
    ];

    delimiters = [
        {
            delimiter: ':'
        },
        {
            delimiter: ','
        }
    ];
    selectedDelimiter = ',';

    commaSeparatedList: any;

    DAASExecutors: any;
    businessLogicExecutors: any;
    sqlQueryExecutors: any;
    workFlowExecutors: any;

    apisByCategory: any;
    dataAccess = [];
    businessLogic = [];
    sql = [];
    workflow = [];
    decision = [];

    DisplayCustomOperation = true;
    executor: any;

    headers = [];
    queryParams = [];
    prerequisites: any;
    showAPIBrowser = true;

    itemList = [];
    filterData: any[];
    settings = {
        text: 'Select attribute(s) to search instantly',
        selectAllText: 'Select All',
        unSelectAllText: 'Unselect All',
        enableSearchFilter: true,
        autoPosition: false
    };
    searchText: string;
    subscriberColumns = [];
    subscribersColumnsLength: number;
    subscribersData: any;
    selectAll = false;
    subscribersChecked = [];
    settingsData: any;
    rightOperandType = [];
    jsonEditorData = [];

    readonly separatorKeysCodes: number[] = [ENTER, COMMA];

    constructor(private _service: ConnecttocrudService, public platform: LeftpanelComponent, public devexListenerInstance: DevexListenerService, public router: Router, public suite: TestsuiteComponent, public dialog: MatDialog, private route: ActivatedRoute,
                private confPost: ConfService, private _formBuilder: FormBuilder, private location: Location, private testSuiteListenerInstance: TestsuiteListenerService) {
        this.options1.mode = 'code';
        this.options1.modes = ['code', 'text', 'tree', 'view'];
        this.options1.schema = '';
        this.options1.statusBar = false;
        this.options1.onChange = () => console.log( /*this.editor.get()*/);
    }

    @Input() testcase = [];
    responses: any;
    responseItems: any;
    @Output() onAddingTestCase: EventEmitter<any> = new EventEmitter<any>();
    Index = 0;
    testCaseName = '';
    currentTestCaseName = '';
    currentTestCaseIndex = 0;
    assert = [];
    steps = {};
    leftOperand = [
        {
            name: 'response',
            value: ''
        },
        {
            name: 'response.body',
            value: ''
        },
        {
            name: 'response.statusCode',
            value: ''
        },
        {
            name: 'response.headers',
            value: ''
        },
    ];
    rightOperand;
    operators = ['=', '≠', '<', '≤', '>', '≥'];

    ngOnInit() {


        this.getCategoriesEntitiesForPartner();
        this.getBusinessLogicApiExecutorsByPartnerAccountType();
        this.getThirdPartyApiExecutorsByPartnerAccountType();
        this.getSqlQueryApiExecutorsByPartnerAccountType();
        this.getWorkFlowApiExecutorsByPartnerAccountType();
        this.basicPermission = true;

        this.confPost.getApiExecutorsForPartnerAccount(localStorage.getItem('partner'), localStorage.getItem('account'))
            .toPromise().then(data => {
            let apiExecutors: any;
            apiExecutors = data;
            const tempCategoryarray = [];
            const tempCategoryarray1 = [];
            const tempCategoryarray2 = [];
            const tempCategoryarray3 = [];

            for (let i = 0; i < apiExecutors.length; i++) {
                for (let j = 0; j < apiExecutors[i]['executors'].length; j++) {
                    switch (apiExecutors[i]['executors'][j]['executor_type']) {
                        case 'API':
                            const apiName = apiExecutors[i]['executors'][j]['executor_category'] + '_' + apiExecutors[i]['executors'][j]['executor_version'];
                            if (tempCategoryarray.includes(apiName) === false) {
                                tempCategoryarray.push(apiName);
                                this.APIExecutorCategory.push(
                                    {
                                        'category': apiExecutors[i]['executors'][j]['executor_category'],
                                        'version': apiExecutors[i]['executors'][j]['executor_version'],
                                        'categoryAndVersion': apiName
                                    });
                                this.DataAccessAPIByCategory[apiExecutors[i]['executors'][j]['executor_category']] = [];
                            }
                            break;
                        case 'WORKFLOW':
                            const apiName1 = apiExecutors[i]['executors'][j]['executor_category'] + '_' + apiExecutors[i]['executors'][j]['executor_version'];
                            if (tempCategoryarray1.includes(apiName1) === false) {
                                tempCategoryarray1.push(apiName1);
                                this.WorkflowAPIExecutorCategory.push(
                                    {
                                        'category': apiExecutors[i]['executors'][j]['executor_category'],
                                        'version': apiExecutors[i]['executors'][j]['executor_version'],
                                        'categoryAndVersion': apiName1
                                    });
                                this.WorkflowAPIByCategory[apiExecutors[i]['executors'][j]['executor_category']] = [];
                            }
                            break;
                        case 'BUSINESSLOGIC':
                            const apiName2 = apiExecutors[i]['executors'][j]['executor_category'] + '_' + apiExecutors[i]['executors'][j]['executor_version'];
                            if (tempCategoryarray2.includes(apiName2) === false) {
                                tempCategoryarray2.push(apiName2);
                                this.businessLogicAPIExecutorCategory.push(
                                    {
                                        'category': apiExecutors[i]['executors'][j]['executor_category'],
                                        'version': apiExecutors[i]['executors'][j]['executor_version'],
                                        'categoryAndVersion': apiName2
                                    });
                                this.businessLogicAPIByCategory[apiExecutors[i]['executors'][j]['executor_category']] = [];
                            }
                            break;
                        case 'SQLQUERY':
                            const apiName3 = apiExecutors[i]['executors'][j]['executor_category'] + '_' + apiExecutors[i]['executors'][j]['executor_version'];
                            if (this.businessLogicAPIExecutorCategory.includes(apiName3) === false) {
                                tempCategoryarray3.push(apiName3);
                                this.businessLogicAPIExecutorCategory.push(
                                    {
                                        'category': apiExecutors[i]['executors'][j]['executor_category'],
                                        'version': apiExecutors[i]['executors'][j]['executor_version'],
                                        'categoryAndVersion': apiName3
                                    });
                                this.SQLQueryAPIByCategory[apiExecutors[i]['executors'][j]['executor_category']] = [];
                            }
                            break;

                    }
                }
            }

        });

        this.confPost.getCategoriesEntitiesForPartner(localStorage.getItem('partner'), localStorage.getItem('account'))
            .subscribe(data => {
                if (data[0].accounts != null) {
                    data[0].accounts.forEach((accounts) => {
                        if (accounts.categories != null) {
                            this.categories = accounts.categories;
                            for (let i = 0; i < this.categories.length; i++) {
                                for (let j = 0; j < this.categories[i].entities.length; j++) {
                                    const tempJSON = {};
                                    tempJSON['entity'] = this.getEntity(this.categories[i].entities[j]);
                                    tempJSON['version'] = this.getVersion(this.categories[i].entities[j]);
                                    this.entities.push(tempJSON);
                                }
                            }
                        }
                    });
                }
            });

        this.apiByDefinition = [{
            'customType': false,
            'apiAccessPolicy': 'None',
            'attributeName': null,
            'type': null,
            'array': false,
            'size': null,
            'precision': null,
            'autoIncrement': false,
            'defaultValue': null,
            'attributeType': 'None',
            'dataStoragePolicy': 'None',
            'description': null,
            'displayName': null,
            'displayPolicy': 'None',
            'required': false,
            'subType': []

        }];

        this.Index = 0;
        for (const header of this.headersData) {
            if (header['key'] === 'Content-Type') {
                switch (header['value']) {
                    case 'multipart/form-data':
                        this.requestBodySelected = 'form-data';
                        break;
                    case 'application/x-www-form-urlencoded':
                        this.requestBodySelected = 'x-www-form-urlencoded';
                        break;
                    case 'application/json':
                        this.requestBodySelected = 'raw';
                        break;
                    default:
                        this.requestBodySelected = 'none';
                        break;
                }
            }
        }
        if (this.testcase.length) {
            //this.currentTestCaseIndex = this.testcase.length;
            //this.setCurrentTestCase(this.currentTestCaseIndex);
            this.getSelectedRequestBodyType();
        }
    }


    showOptions(event: MatCheckboxChange, index): void {
        if (event.checked) {
            this.subscribersChecked.push(this.subscribersData[index]);
        } else {
            for (let i = 0; i < this.subscribersChecked.length; i++) {
                if (this.subscribersChecked[i]['email'] === this.subscribersData[index]['email']) {
                    this.subscribersChecked.splice(i, 1);
                }
            }
        }
    }

    getCategoriesEntitiesForPartner() {
        // if (this.categories.length === 0) {
        this.confPost.getCategoriesEntitiesForPartner(localStorage.getItem('partner'), localStorage.getItem('account'))
            .subscribe(data => {
                if (data[0].accounts != null) {
                    data[0].accounts.forEach((accounts) => {
                        if (accounts.categories != null) {
                            this.categories = accounts.categories;
                            if (this.categories && this.categories.length > 0) {
                                this.DisplayApiByCategory = true;
                                this.DisplayCustomOperation = true;
                            } else {
                                this.DisplayApiByCategory = false;
                                this.DisplayCustomOperation = false;
                            }
                        }
                    });
                }
            });
        // }
    }

    async getBusinessLogicApiExecutorsByPartnerAccountType() {
        if (this.platform.businessLogicExecutors !== null && this.platform.businessLogicExecutors !== undefined && this.platform.businessLogicExecutors !== '') {
            this.businessLogicExecutors = this.platform.businessLogicExecutors;
        } else {
            await this.platform.getExecutorsForPartnerAccount().then(resp => {
                this.businessLogicExecutors = this.platform.businessLogicExecutors;
            });

            // await this.confPost.getApiExecutorsByPartnerAccountType(this.partner, this.account, 'BUSINESSLOGIC').toPromise().then(data => {
            //     this.businessLogicExecutors = data;
            //     this.platform.businessLogicExecutors = data;
            //     // localStorage.setItem('businessLogicAPI' , JSON.stringify(this.executors));
            // }, error => {
            //     this.platform.openSnackBar('Error while fetching Business Logic APIs', 'Error', {
            //         duration: 5000,
            //         verticalPosition: 'top',
            //         horizontalPosition: 'center'
            //     });
            // });
        }

    }

    getThirdPartyApiExecutorsByPartnerAccountType() {
        // this.confPost.getApiExecutorsByPartnerAccountType(this.partner, this.account, 'THIRDPARTY').subscribe(data => {
        //     this.thirdPartyApiExecutors = data;
        //     // localStorage.setItem('dataAccessAPI' , JSON.stringify(this.apiExecutors));
        // });
        this.confPost.getApiExecutorsForPartnerAccount(this.partner, this.account).subscribe(data => {
            // this.thirdPartyApiExecutors = data;
            this.apisByCategory = data;
            for (let i = 0; i < this.apisByCategory.length; i++) {
                const tempDataAccess = [];
                const tempbusinessLogic = [];
                const tempsql = [];
                const tempworkflow = [];
                const tempdecision = [];
                for (let j = 0; j < this.apisByCategory[i]['executors'].length; j++) {
                    let temp: string;
                    temp = '';
                    if (this.apisByCategory[i]['executors'][j]['executor_type'] === 'API') {
                        tempDataAccess.push(this.apisByCategory[i]['executors'][j]['executor_name'] + '#' + this.apisByCategory[i]['executors'][j]['executor_version']);
                    } else if (this.apisByCategory[i]['executors'][j]['executor_type'] === 'BUSINESSLOGIC') {
                        tempbusinessLogic.push(this.apisByCategory[i]['executors'][j]['executor_name'] + '#' + this.apisByCategory[i]['executors'][j]['executor_version']);
                    } else if (this.apisByCategory[i]['executors'][j]['executor_type'] === 'SQLQUERY') {
                        tempsql.push(this.apisByCategory[i]['executors'][j]['executor_name'] + '#' + this.apisByCategory[i]['executors'][j]['executor_version']);
                    } else if (this.apisByCategory[i]['executors'][j]['executor_type'] === 'WORKFLOW') {
                        tempworkflow.push(this.apisByCategory[i]['executors'][j]['executor_name'] + '#' + this.apisByCategory[i]['executors'][j]['executor_version']);
                    } else if (this.apisByCategory[i]['executors'][j]['executor_type'] === 'DECISION') {
                        tempdecision.push(this.apisByCategory[i]['executors'][j]['executor_name'] + '#' + this.apisByCategory[i]['executors'][j]['executor_version']);
                    }
                }
                if (tempDataAccess.length > 0) {
                    this.dataAccess.push({'executors': tempDataAccess, 'category': this.apisByCategory[i]['category']});
                }
                if (tempbusinessLogic.length > 0) {
                    this.businessLogic.push({
                        'executors': tempbusinessLogic,
                        'category': this.apisByCategory[i]['category']
                    });
                }
                if (tempsql.length > 0) {
                    this.sql.push({'executors': tempsql, 'category': this.apisByCategory[i]['category']});
                }
                if (tempworkflow.length > 0) {
                    this.workflow.push({'executors': tempworkflow, 'category': this.apisByCategory[i]['category']});
                }
                if (tempdecision.length > 0) {
                    this.decision.push({'executors': tempdecision, 'category': this.apisByCategory[i]['category']});
                }
            }
        });
    }

    getSqlQueryApiExecutorsByPartnerAccountType() {
        if (this.platform.sqlQueryExecutors !== null && this.platform.sqlQueryExecutors !== undefined && this.platform.sqlQueryExecutors !== '') {
            this.sqlQueryExecutors = this.platform.sqlQueryExecutors;
        } else {

            this.platform.getExecutorsForPartnerAccount().then(resp => {
                this.sqlQueryExecutors = this.platform.sqlQueryExecutors;
                localStorage.setItem('sqlQueryAPI', JSON.stringify(this.sqlQueryExecutors));
            });

            // this.confPost.getApiExecutorsByPartnerAccountType(this.partner, this.account, 'SQLQUERY').subscribe(data => {
            //     this.sqlQueryExecutors = data;
            //     this.platform.sqlQueryExecutors = data;
            //     localStorage.setItem('sqlQueryAPI', JSON.stringify(this.sqlQueryExecutors));
            // }, error => {
            //     this.platform.openSnackBar('Error while fetching SQL Query APIs', 'Error', {
            //         duration: 5000,
            //         verticalPosition: 'top',
            //         horizontalPosition: 'center'
            //     });
            // });
        }
    }

    getWorkFlowApiExecutorsByPartnerAccountType() {
        if (this.platform.workFlowExecutors !== null && this.platform.workFlowExecutors !== undefined && this.platform.workFlowExecutors !== '') {
            this.workFlowExecutors = this.platform.workFlowExecutors;
        } else {

            this.platform.getExecutorsForPartnerAccount().then(resp => {
                this.workFlowExecutors = this.platform.workFlowExecutors;
                localStorage.setItem('workFlowAPI', JSON.stringify(this.workFlowExecutors));
            });

            // this.confPost.getApiExecutorsByPartnerAccountType(this.partner, this.account, 'WORKFLOW').subscribe(data => {
            //     this.workFlowExecutors = data;
            //     this.platform.workFlowExecutors = this.workFlowExecutors;
            //     localStorage.setItem('workFlowAPI', JSON.stringify(this.workFlowExecutors));
            // }, error => {
            //     this.platform.openSnackBar('Error while fetching Workflow APIs.', 'Error', {
            //         duration: 5000,
            //         verticalPosition: 'top',
            //         horizontalPosition: 'center'
            //     });
            // });
        }
    }

    getMenu(val) {
        if (val != null) {
            return val.replace(/ /g, '');
        } else {
            return 'Default';
        }

    }

    getEntity(val) {
        const data = val.split('#');
        return data[0];
    }

    getVersion(val) {
        const data = val.split('#');
        return data[1];
    }


    getBackgroundStyle(val) {
        if (val === 'GET') {
            return 'get-method';
        } else if (val === 'PUT') {
            return 'put-method';
        } else if (val === 'POST') {
            return 'post-method';
        } else if (val === 'DELETE') {
            return 'delete-method';
        } else {
            return 'get-method';
        }
    }

    collapsePanel() {
        $('#collapsablePanel').css('display', 'none');
        $('#devexGeneric').removeClass('col-md-9 col-lg-9 col-sm-12 col-xs-12').addClass('col-md-12 col-lg-12 col-sm-12 col-xs-12');
        $('.URL-Field').removeClass('col-lg-9 col-md-9').addClass('col-lg-7 col-md-7');
        this.showAPIBrowser = true;

    }

    selectAPI() {
        $('#collapsablePanel').addClass('col-md-3 col-lg-3 col-sm-12 col-xs-12').css('display', 'block');
        $('#devexGeneric').removeClass('col-md-12 col-lg-12 col-sm-12 col-xs-12').addClass('col-md-9 col-lg-9 col-sm-12 col-xs-12');
        $('.URL-Field').removeClass('col-lg-7 col-md-7').addClass('col-lg-9 col-md-9');
        this.showAPIBrowser = false;


    }


    fetchExecutor(item) {
        this.confPost.getApiExecutorByPartnerAccountByNameAndVersion(this.partner, this.account, this.getEntity(item), this.getVersion(item)).subscribe(exec => {
            this.executor = exec;
            this.httpUrl = this.executor.apiUrl;
            this.executor_name = this.executor.executor_name;
            this.executor_version = this.executor.executor_version;
            this.executor_type = this.executor.executor_type;
            this.executor_method_type = this.executor.executor_method_type;
            this.httpOperation = this.executor.executor_method_type;
            this.parameterData = this.executor.queryParams;
            this.pathParameter = this.executor.pathParams;
            this.authModel = this.executor.authModel;
            this.headersData = this.executor.headers;


            this.testcase[this.currentTestCaseIndex].apiUrl = this.executor.apiUrl;
            this.executor_name = this.executor.executor_name;
            this.testcase[this.currentTestCaseIndex].executor_version = this.executor.executor_version;
            this.executor_type = this.executor.executor_type;
            this.testcase[this.currentTestCaseIndex].executor_method_type = this.executor.executor_method_type;
            this.testcase[this.currentTestCaseIndex].executor_method_type = this.executor.executor_method_type;
            this.testcase[this.currentTestCaseIndex].queryParams = this.executor.queryParams ? this.executor.queryParams : [];
            this.testcase[this.currentTestCaseIndex].pathParams = this.executor.pathParams;
            this.testcase[this.currentTestCaseIndex].authModel = this.executor.authModel;
            this.testcase[this.currentTestCaseIndex].headers = this.executor.headers ? this.executor.headers : [];

            for (const header of this.headersData) {
                if (header['key'] === 'Content-Type') {
                    switch (header['value']) {
                        case 'multipart/form-data':
                            this.requestBodySelected = 'form-data';
                            this.formData = this.executor.requestBody.value;
                            this.formDataTrue = true;
                            this.formURLEncodedTrue = false;
                            break;
                        case 'application/x-www-form-urlencoded':
                            this.requestBodySelected = 'x-www-form-urlencoded';
                            this.formData = this.executor.requestBody.value;
                            this.formDataTrue = false;
                            this.formURLEncodedTrue = true;
                            break;
                        case 'application/json':
                            this.requestBodySelected = 'raw';
                            this.rawRequestBody = this.executor.requestBody.value;
                            break;
                        default:
                            this.requestBodySelected = 'none';
                            break;
                    }
                }
            }
            this.requestBody = this.executor.requestBody;
            this.executors = this.executor.executors;
            if (this.executor.responseAttributes !== null) {
                this.apiByDefinition = this.executor.responseAttributes;
            }
            this.platform.openSnackBar('Executor selected', 'Success', {
                duration: 3000,
                verticalPosition: 'top',
                horizontalPosition: 'center'
            });
        });
    }


    //testCases
    deleteAssert(a) {
        this.assert.splice(a, 1);
    }

    deleteTestCase(i) {

        if(this.testcase[this.currentTestCaseIndex] === undefined){
            this.platform.openSnackBar('No data found to be deleted', 'Error', {
                duration: 3000,
                verticalPosition: 'top',
                horizontalPosition: 'center'
            });
        }
        else {
            const clickMessage = this.editFlag === true ? 'testsuite_edit_deletestep_clicked' : 'testsuite_create_deletestep_clicked';

            Promise.resolve(this.platform.generateActionPayloadForAudit(false, clickMessage, 'INFO', 200, 'OK', '', '', '', this.router.url)).then(response1 => {
                const payloadToSend = {
                    actions: response1
                };
                this.testSuiteListenerInstance.testSuiteListener.emit({
                    type: 'audit',
                    id: localStorage.getItem('IdOfSession'),
                    payload: payloadToSend
                });
            });


            const dialogRef = this.dialog.open(ConfirmTestcaseDeletionComponent, {
                width: '400px',
                data: {name: this.testcase[this.currentTestCaseIndex].executor_name}
            });
            dialogRef.afterClosed().subscribe(response => {
                if (response && response === 'yes') {
                    this.testcase.splice(i, 1);
                    this.testcaseRequestBody.splice(i, 1);
                    this.currentTestCaseIndex = this.currentTestCaseIndex !== 0 ? this.currentTestCaseIndex - 1 : this.currentTestCaseIndex;
                    this.currentTestCaseName = this.testcase.length ? this.testcase[this.currentTestCaseIndex].name : '';
                    this.Index = this.Index !== 0 ? this.Index - 1 : this.Index;
                    if (this.type === 'pre test') {
                        // this.platform.openSnackBar('Test setup step deleted successfully', 'Success', {
                        //     duration: 3000,
                        //     verticalPosition: 'top',
                        //     horizontalPosition: 'center'
                        // });
                    } else if (this.type === 'post test') {
                        // this.platform.openSnackBar('Tear down step deleted successfully', 'Success', {
                        //     duration: 3000,
                        //     verticalPosition: 'top',
                        //     horizontalPosition: 'center'
                        // });
                    }
                    if (!this.testcase.length) {
                        this.showAPIBrowser = true;
                    }
                }
            });
        }

    }

    addAssert() {
        let temp = {
            executor_type: 'logic_compare',
            operator: '',
            leftOperand: {
                name: 'a',
                type: 'attributes',
                field: '',
                disabled: false
            },
            rightOperand: {
                executor_type: 'text',
                field: '',
                disabled: false
            },
            disabled: false
        };
        this.assert.push(temp);
        this.rightOperandType.push('TEXT');
        this.jsonEditorData.push({});
    }

    saveAssert(index) {
    }

    delete(i) {
        this.suite.testcase.splice(i, 1);
    }


    setCurrentTestCase(index) {
        if (this.testcase.length) {
            if (this.testcase[index].requestBody === {}) {
                this.saveStep(this.currentTestCaseIndex);
            }
        }
        this.currentTestCaseIndex = index;
        this.currentTestCaseName = this.testcase[index].executor_name;
        this.getSelectedRequestBodyType();
    }

    resetAttributes() {
        //this.httpOperation = '';
        //this.httpUrl = '';
        //this.headersData = [];
        //this.requestBody = {};
    }

    openDialog() {

        let clickMessage = '';

        if (this.editFlag === true) {
            clickMessage = this.type === 'pre test' ? 'testsuite_edit_addprestep_clicked' : 'testsuite_edit_addpoststep_clicked';
        } else {
            clickMessage = this.type === 'pre test' ? 'testsuite_create_addprestep_clicked' : 'testsuite_create_addpoststep_clicked';
        }

        Promise.resolve(this.platform.generateActionPayloadForAudit(false, clickMessage, 'INFO', 200, 'OK', '', '', '', this.router.url)).then(response1 => {
            const payloadToSend = {
                actions: response1
            };
            this.testSuiteListenerInstance.testSuiteListener.emit({
                type: 'audit',
                id: localStorage.getItem('IdOfSession'),
                payload: payloadToSend
            });
        });

        //this.testCaseName = 'Test Case ' + (this.Index) + 1;
        const dialogRef = this.dialog.open(TestCaseNameInputDialog, {
            width: '400px',
            data: {name: '', type: this.type === 'pre test' ? 'test setup step' : 'tear down step'}
        });
        dialogRef.afterClosed().subscribe(name => {
            if (name && name !== '' && name !== ' ') {
                const duplicateTestCases = this.testcase.filter((v, i) => v.executor_name === name);
                if (!duplicateTestCases.length) {
                    if (this.testcase.length) {
                        this.saveStep(this.currentTestCaseIndex);
                    }
                    //if (this.Index > 0) {
                    this.testCaseName = name;
                    this.currentTestCaseName = name;
                    this.resetAttributes();
                    this.addTestCase();
                    //}
                    this.currentTestCaseIndex = this.Index;
                    this.getSelectedRequestBodyType();
                    this.Index = this.Index + 1;
                } else {
                    const msgText = this.type === 'pre test' ? 'Setup step' : 'Tear down step';
                    this.platform.openSnackBar(msgText + ' named ' + name + ' already exists', 'Error', {
                        duration: 3000,
                        verticalPosition: 'top',
                        horizontalPosition: 'center'
                    });
                    this.openDialog();
                }

            }
        });
    }

    async addTestCase() {

        const temp = {
            'executor_name': this.testCaseName,
            'executor_type': 'API',
            'authModel': '',
            //'executor_version': this.executor_version,
            'executor_method_type': '',
            'apiUrl': '',
            'dataroot': null,
            'queryParams': [],
            'pathParams': [],
            'headers': [],
            'requestBody': {},
            'response': null,
            'prerequisites': null
        };
        this.testcase.push(temp);
        this.testcaseRequestBody.push(HeadersComponent);
        this.assert = [];
    }


    async savePreSteps(){
    if(this.testcase.length === 0) {
            this.platform.openSnackBar('No data found to be saved', 'Error', {
            duration: 3000,
            verticalPosition: 'top',
            horizontalPosition: 'center'
    });}  else
    {
    let clickMessage = '';

    if (this.editFlag === true) {
        clickMessage = this.type === 'pre test' ? 'testsuite_edit_savepresteps_clicked' : 'testsuite_edit_savepoststeps_clicked';
    } else {
        clickMessage = this.type === 'pre test' ? 'testsuite_create_savepresteps_clicked' : 'testsuite_create_savepoststeps_clicked';
    }

    Promise.resolve(this.platform.generateActionPayloadForAudit(false, clickMessage, 'INFO', 200, 'OK', '', '', '', this.router.url)).then(response1 => {
        const payloadToSend = {
            actions: response1
        };
        this.testSuiteListenerInstance.testSuiteListener.emit({
            type: 'audit',
            id: localStorage.getItem('IdOfSession'),
            payload: payloadToSend
        });
    });

    this.testcase[this.testcase.length - 1].requestBody = await this.headerChild.getRequestBody();
    if (this.type === 'pre test') {
        this.onCompletingPreSteps.emit(this.testcase);
        this.platform.openSnackBar('Test setup steps saved successfully', 'Success', {
            duration: 3000,
            verticalPosition: 'top',
            horizontalPosition: 'center'
        });
    } else if (this.type === 'post test') {
        this.onCompletingTearDownSteps.emit(this.testcase);
        this.platform.openSnackBar('Tear down steps added successfully', 'Success', {
            duration: 3000,
            verticalPosition: 'top',
            horizontalPosition: 'center'
        });
    }
}
    }


    async saveStep(index) {
        this.testcase[index].requestBody = await this.headerChild.getRequestBody();
        //this.testcaseRequestBody[this.currentTestCaseIndex] = await this.headerChild.getRequestBody();
    }

    getSelectedRequestBodyType() {
        const headers = this.testcase[this.currentTestCaseIndex].headers;
        if (!headers.length) {
            this.requestBodySelected = 'none';
            this.rawRequestBody = {};
            this.formData = [];
        }
        for (const header of headers) {
            if (header['key'] === 'Content-Type') {
                switch (header['value']) {
                    case 'multipart/form-data':
                        this.requestBodySelected = 'form-data';
                        this.formData = this.testcase[this.currentTestCaseIndex].requestBody.value;
                        this.formDataTrue = true;
                        this.formURLEncodedTrue = false;
                        break;
                    case 'application/x-www-form-urlencoded':
                        this.requestBodySelected = 'x-www-form-urlencoded';
                        this.formData = this.testcase[this.currentTestCaseIndex].requestBody.value;
                        this.formDataTrue = false;
                        this.formURLEncodedTrue = true;
                        break;
                    case 'application/json':
                        this.requestBodySelected = 'raw';
                        this.rawRequestBody = this.testcase[this.currentTestCaseIndex].requestBody.value;
                        break;
                    default:
                        this.requestBodySelected = 'none';
                        break;
                }
            }
        }
    }

    getRawRequestBody() {

    }

    getRequestBodyValue(val) {
        switch (val) {
            case 'raw':
                // return JSON.stringify(this.editor.get());
                return this.editor.get();
            case 'binary':
            case 'none':
            default:
        }
    }

    getRequestBody() {
        if (this.requestBodySelected === 'raw') {
            const requestbody = {
                'value': this.getRequestBodyValue(this.requestBodySelected),
                'key': 'payload',
                'description': 'Document in JSON format',
                'annotation': 'RequestBody'
            };
            return requestbody;
        } else if (this.requestBodySelected === 'form-data') {
            const requestbody = {
                'value': this.formData,
                'key': 'payload',
                'description': 'Document in JSON format',
                'annotation': 'RequestBody'
            };
            return requestbody;
        } else if (this.requestBodySelected === 'x-www-form-urlencoded') {
            const requestbody = {
                'value': this.formData,
                'key': 'payload',
                'description': 'Document in JSON format',
                'annotation': 'RequestBody'
            };
            return requestbody;
        } else if (this.requestBodySelected === 'none') {
            const requestbody = null;
            return requestbody;
        }
    }

    parameterDataCheck(event: any) {
        // /: calculation
        if (this.devExURL !== event.target.value) {
            this.devExURL = event.target.value;
            this.pathParameterSegregator = this.devExURL.split('/:');
            for (let i = 1; i < this.pathParameterSegregator.length; i++) {
                this.pathParameterStopper = this.pathParameterSegregator[i].split('/');
                this.pathParameterSegregator[i] = this.pathParameterStopper[0];
            }
            // {} for calculation
            let temp2 = this.devExURL.split('/');
            // /: append
            this.pathParameter = [];
            for (let i = 1; i < this.pathParameterSegregator.length; i++) {
                this.pathParameterValue = this.pathParameterSegregator[i];
                this.find = true;
                for (let j = 0; j < this.pathParameter.length; j++) {
                    if (this.pathParameterSegregator[i] === this.pathParameter[j]['key']) {
                        this.find = false;
                    }
                }
                if (this.find === true) {
                    this.pathParameter.push({'key': this.pathParameterValue, 'value': '', 'description': ''});
                }
            }
            // {} append
            for (let i = 2; i < temp2.length; i++) {
                const init = temp2[i].indexOf('{');
                const fin = temp2[i].indexOf('}');
                if ((!(this.pathParameter.some(e => e.key === temp2[i].substr(init + 1, fin - init - 1))) && temp2[i].substr(init + 1, fin - init - 1) !== '') && init !== -1 && fin !== -1) {
                    this.pathParameter.push({
                        'key': temp2[i].substr(init + 1, fin - init - 1),
                        'value': '',
                        'description': ''
                    });
                }
            }
            // confirm to show the path parameter area.
            if (this.pathParameter.length !== 0) {
                this.showPathParameters = true;
            } else {
                this.showPathParameters = false;
            }
        }
    }

    checkQueryParams(event) {
        const tempUrl = event.target.value;
        const seperator = tempUrl.split('/');
        let query: any;
        let finalquery: any;
        if (seperator.length > 0) {
            query = seperator[seperator.length - 1].split('?');
            if (query.length > 1) {
                finalquery = query[query.length - 1].split('&');
                if (finalquery) {
                    for (let i = 0; i < finalquery.length; i++) {
                        let temp = finalquery[i].split('=');
                        let flag = false;
                        for (let j = 0; j < this.parameterData.length; j++) {
                            if (temp[0].includes(this.parameterData[j]['key']) || this.parameterData[j]['key'].includes(temp[0]) || this.parameterData[j]['key'] === temp[0]) {
                                flag = true;
                                if (temp.length > 1) {
                                    this.parameterData[j]['key'] = temp[0];
                                    this.parameterData[j]['value'] = temp[1];
                                } else {
                                    this.parameterData[j]['key'] = temp[0];
                                    this.parameterData[j]['value'] = '';
                                }
                            }
                        }
                        if (flag === false) {
                            if (temp.length > 1) {
                                this.parameterData.push({key: temp[0], value: temp[1], description: ''});
                            } else {
                                this.parameterData.push({key: temp[0], value: '', description: ''});
                            }
                        }
                    }
                }
            }
        }
    }

    async executeApi() {
        this.executor['requestBody'] = await this.headerChild.getRequestBody();

        const payload = {
            //'executor_name': this.executor_name,
            'executor_type': 'API',
            //'executor_version': this.executor_version,
            'executor_method_type': this.httpOperation,
            'apiUrl': this.httpUrl,
            'dataroot': null,
            'queryParams': this.parameterData,
            'pathParams': this.pathParameter,
            'headers': this.headersData,
            'requestBody': await this.headerChild.getRequestBody(),
            //'executors': this.executors,
            'prerequisites': null
        };

        let temp = this.testcase[this.currentTestCaseIndex];
        temp['testExecutorModel'] = this.executor;
        let leftOperandFieldString = this.executor['executor_type'] + '_' + this.executor['executor_name'] + '_' + this.executor['executor_version'] + '>';
        for (let i = 0; i < this.assert.length; i++) {
            if (this.assert[i].leftOperand['field'] === 'response.statusCode') {
                this.assert[i].rightOperand['executor_type'] = 'math_number';
            }
            if (!this.assert[i].leftOperand['field'].includes(leftOperandFieldString)) {
                this.assert[i].leftOperand['field'] = leftOperandFieldString + this.assert[i].leftOperand['field'];
                const parser = new DOMParser();
            }
            if (this.rightOperandType[i] === 'JSON') {
                let temp = {
                    disabled: false,
                    executor_type: 'parse_string',
                    value: this.assert[i].leftOperand
                };
                this.assert[i].leftOperand = temp;
                this.assert[i].rightOperand['field'] = JSON.stringify(this.editor.get());
            }
        }

        temp['apiResponseAssertions']['rules'] = this.assert;
        this.testcase.splice(this.currentTestCaseIndex, 1, temp);
        this.onAddingTestCase.emit(this.testcase);
        this.platform.openSnackBar('Testcase added successfully', 'Success', {
            duration: 5000,
            verticalPosition: 'top',
            horizontalPosition: 'center'
        });
        // temp['headersData'] = this.headersData;
        // temp['requestBody'] = await this.headerChild.getRequestBody();
        // temp['parameterData'] = this.parameterData;
        // temp['pathParameter'] = this.pathParameter;

        // this._service.executeApi(payload).subscribe(response2 => {
        //     this.responses = response2;
        //     this.responseItems = JSON.stringify(this.responses.body);
        // });

        // temp['responseData'] = this.responses;
        //

        // this.testcase.splice(this.currentTestCaseIndex,1,temp);
    }


    hasPreStepsPermissions() {
        if (this.editFlag === true) {
            return this.platform.hasPermissions(['EDIT_PRE_STEPS_TEST_SUITE_API', 'edit_pre_steps:' + this.partner + '=>' + this.account + '=>' + this.executor_name + '=>' + this.executor_version]);
        } else {
            return this.platform.hasPlatformPermission('CREATE_PRE_STEPS_TEST_SUITE_API');
        }
    }

    hasTearDownPermissions() {
        if (this.editFlag === true) {
            return this.platform.hasPermissions(['EDIT_TEAR_DOWN_TEST_SUITE_API', 'test:' + this.partner + '=>' + this.account + '=>' + this.executor_name + '=>' + this.executor_version]);
        } else {
            return this.platform.hasPlatformPermission('CREATE_TEAR_DOWN_TEST_SUITE_API');
        }
    }

    hasAddTestCasePermission() {
        if (this.editFlag === true) {
            return this.platform.hasPermissions(['EDIT_TEST_CASE_TEST_SUITE_API', 'edit_test_case:' + this.partner + '=>' + this.account + '=>' + this.executor_name + '=>' + this.executor_version]);
        } else {
            return this.platform.hasPlatformPermission('ADD_TEST_CASE_TEST_SUITE_API');
        }
    }

    hasDeleteTestCasePermissions() {
        if (this.editFlag === true) {
            return this.platform.hasPermissions(['DELETE_TEST_CASE_TEST_SUITE_API', 'delete_test_case:' + this.partner + '=>' + this.account + '=>' + this.executor_name + '=>' + this.executor_version]);
        } else {
            return this.platform.hasPlatformPermission('DELETE_TEST_CASE_TEST_SUITE_API');
        }
    }

    hasRulePermissions() {
        if (this.editFlag === true) {
            return this.platform.hasPermissions(['EDIT_RULE_TEST_SUITE_API', 'edit_rule:' + this.partner + '=>' + this.account + '=>' + this.executor_name + '=>' + this.executor_version]);
        } else {
            return this.platform.hasPlatformPermission('ADD_RULE_TEST_SUITE_API');
        }
    }

    hasDeleteRulePermissions() {
        if (this.editFlag === true) {
            return this.platform.hasPermissions(['DELETE_RULE_TEST_SUITE_API', 'delete_rule:' + this.partner + '=>' + this.account + '=>' + this.executor_name + '=>' + this.executor_version]);
        } else {
            return this.platform.hasPlatformPermission('DELETE_RULE_TEST_SUITE_API');
        }
    }

    hasAPIBrowserPermissions() {
        if (this.editFlag === true) {
            return this.platform.hasPermissions(['SHOW_API_BROWSER_TEST_SUITE_API', 'show_api_browser:' + this.partner + '=>' + this.account + '=>' + this.executor_name + '=>' + this.executor_version]);
        } else {
            return this.platform.hasPlatformPermission('SHOW_API_BROWSER_TEST_SUITE_API');
        }
    }

    teardownCompleted(payload) {
        this.onCompletingTearDownSteps.emit(payload);
    }

    toggleExecutorWithID(ev, id) {
        const targetId = 'cat' + id;
        $(targetId).hasClass('in') ? $(targetId).removeClass('in') : $(targetId).addClass('in');
        //$(targetId).slideToggle();
        $(ev.target).toggleClass('fa-chevron-down fa-chevron-up');
    }

    toggleExecutor(ev) {
        $('.executor-definition').slideToggle();
        $(ev.target).toggleClass('fa-chevron-down fa-chevron-up');
    }
}
